// Object with the list of all Ditto system collections that are being
// accessed by the portal.
export const SystemCollections = {
  // Collection under which the auth webhooks config is saved.
  APP_WEBHOOKS_COLLECTION: '__auth_config',
  // Collection under which the live query webhooks is saved.
  APP_LIVE_QUERY_WEBHOOKS_COLLECTION: '__hydra_webhooks',
  // Collection under which the live query webhooks config is saved.
  APP_LIVE_QUERY_WEBHOOKS_API_COLLECTION: '__hydra_webhooks_api',
  // Collections used to configure Hydra features.
  APP_HYDRA_FEATURES_COLLECTION: '__hydra_features',
  // Collection which stores the Live Query source configuration with an item per Source
  LIVE_QUERY_SOURCES_COLLECTION: '__live_query_sources',
  // Collection which stores the Live Query sink configuration with an item per Sink
  LIVE_QUERY_SINKS_COLLECTION: '__live_query_sinks',
  // Collection where devices' info is gathered.
  SMALL_PEER_INFO_COLLECTION: '__small_peer_info',
  // Collection where app builder projects are stored
  FORGE_PROJECTS_COLLECTION: '__projects',
  // Collection where the status of the MongoDB connector is stored
  MONGO_CONNECTOR_STATUS: '__mdb_connector_status',
  // Collection where the initial sync status of MongoDB connector is stored
  MONGO_CONNECTOR_INITIAL_SYNC_STATUS: '__mdb_initial_sync_status',
}

// Object with the list of IDs used to access elements inside of system collections
// accessed by the portal.
export const SystemIds = {
  // ID used to store the document with the configuration for all authentication webhooks.
  AUTH_WEBHOOKS_CONFIGURATION: 'auth_config',
  // ID used to store the document with the live query webhook api secrets.
  AUTH_LIVE_QUERY_WEBHOOKS_API_SECRET: 'api_secrets',
  // ID used to save kafka settings inside the Hydra feaures collection
  HYDRA_KAFKA_FEATURES: 'kafka',
  // ID used to save the status of the MongoDB connector
  MONGO_DB_CONNECTOR: 'MongoDbConnector',
}
